import React from "react";
import './SidebarRight.css';

function SidebarRight({
  views,
  description,
  timestamp,
  channel,
  title,
  image,
}) {
  return (
    <div className="sidebar__box">
      <div className="sidebar">
      <img src={image} alt="" / >
      <div className="sidebar__text">
        <h3>{title}</h3>
        <p className="sidebar__headline">
          <div>{channel}</div>
          {views} views . {timestamp}
        </p>
        <p className="sidebar__description">{description}</p>
      </div>
    </div>
    </div>
  )
}

export default SidebarRight
